<template>

    <div class="form-check">
        <label class="form-check-label">
            <input v-model="handler" class="form-check-input" type="checkbox" @change="change">
            {{ label }}
        </label>
    </div>

</template>



<script>

export default {
  props: ['config', 'name', 'value','label'],
  data(){
      return {
          handler:[],
      }
  },
  mounted(){
      this.handler = this.value;
  },
  methods:{
    change(){
        this.$emit('change',this.handler);
    },
  }

}
</script>
